<template>
<div v-if="items && items.length > 0" class="ta-l p-a-4 hubspot-form">
  <div v-for="(item, index) in items" :key="index" :class="`${index !== 0 ? 'm-t-2' : ''}`">
    <p class="card-content-title ta-l">{{ item.name }}</p>
    <component :is="item.component" :placeholder="item.placeholder" v-model="form[item.name]" />
  </div>
  <Button @click="send" :loading="state === 'sending'" :disabled="state === 'sending'" :class="`m-t-2 ${state === 'sent' ? 'green' : ''}`">Send</Button>
</div>
</template>

<script>
export default {
  props: {
    portalID: {
      type: String,
      required: true,
    },
    formGUID: {
      type: String,
      required: true,
    },
    pageName: {
      type: String,
      default: 'Dashboard',
    },
    items: {
      type: Array,
      required: true,
      default: null,
    },
    hiddenValues: {
      type: Array,
      default: () => ([]),
    },
  },
  methods: {
    /**
     * Send form to hubspot *shillz down mah spajn*
     */
    async send() {
      const postData = {
        fields: [],
        context: {
          pageUri: window.location.href,
          pageName: this.pageName,
        },
      };

      let sendable = true;
      this.items.forEach((item) => {
        if (item.required && (typeof this.form[item.name] === 'undefined' || this.form[item.name] === '')) {
          sendable = false;
        }
        postData.fields.push({ name: item.name, value: this.form[item.name] });
      });

      this.hiddenValues.forEach(({ name, value }) => {
        postData.fields.push({ name, value });
      });

      if (!sendable) {
        return;
      }

      this.state = 'sending';

      const response = await fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${this.portalID}/${this.formGUID}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData),
      }).then(() => true).catch(() => false);

      if (!response) {
        swal({ title: 'An error occured', text: 'For some reason we could not send this information right now', icon: 'error' });
        this.state = '';
        return;
      }

      this.state = 'sent';

      setTimeout(() => {
        this.state = '';
        this.$emit('close', true);
      }, 2000);
    },
  },
  data() {
    return {
      form: {},
      state: '',
    };
  },
  mounted() {
    this.items.forEach((item) => {
      if (item.value) {
        this.form[item.name] = item.value;
      }
    });
  },
};
</script>

<style lang="scss">
.hubspot-form {
  .textarea {
    max-height: 300px;

    & > div {
      height: auto !important;
    }

    .tui-editor-contents {
      min-height: 150px !important;
      max-height: 150px !important;
    }
  }
}
</style>
